// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item___if88","img":"styles_img__5ynmp","pulse":"styles_pulse___e238","jump":"styles_jump__JLmwD"};